export const queryParamsToObject = <T>(query: string) => {
    let obj = {};
    query = query.charAt(0) === "?" ? query.slice(1) : query;
    query.split('&').forEach((pair: any) => {
        pair = pair.split('=');
        obj[pair[0]] = decodeURIComponent(pair[1] || '');
    });
    return obj as T;
};
